import CreateContainer from './components/createContainer';
import { useNavigate } from 'react-router-dom';
import { useCustomerContext } from '../../../utils/customerContext';
import PageMenu from '../../../components/pageMenu/pageMenu';
import AllInvoices from './components/allInvoices';
import OpenInvoices from './components/openInvoices';
import './invoice.css';
import './components/invoice.component.css';
import { useEffect, useState } from 'react';
import { useInvoiceContext } from '../../../utils/invoiceContext';

function Invoice() {
    const navigate = useNavigate();
    const { invoices, fetchInvoices, invoicesHasMore } = useInvoiceContext();
    const { customers } = useCustomerContext();
    const [searchName, setSearchName] = useState('');
    const [selectedSort, setSelectedSort] = useState('date_desc');

    useEffect(() => {
        const timer = setTimeout(() => {
            fetchInvoices(true, searchName, selectedSort);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchName]);

    useEffect(() => {
        fetchInvoices(true, '', selectedSort);
    }, []);

    const handleSortChange = (option) => {
        setSelectedSort(option.id);
        fetchInvoices(true, searchName, option.id);
    };

    const handleNavigate = (id) => {
        navigate(`/dashboard/invoice/${id}`);
    };

    const items = [
        {
            key: 'all',
            label: `Alle Rechnungen (${invoices.length})`,
            component: () => (
                <AllInvoices
                    invoices={invoices}
                    customers={customers}
                    onNavigate={handleNavigate}
                    onLoadMore={() => fetchInvoices(false, searchName, selectedSort)}
                    hasMore={invoicesHasMore}
                    searchName={searchName}
                    setSearchName={setSearchName}
                    selectedSort={selectedSort}
                    onSortChange={handleSortChange}
                />
            )
        },
        {
            key: 'new',
            label: 'Neue Rechnung',
            component: () => <CreateContainer />
        },
        {
            key: 'open',
            label: `Offene Rechnungen (${invoices.filter(i => !i.isPaid).length})`,
            component: () => (
                <OpenInvoices 
                    invoices={invoices} 
                    customers={customers} 
                    onNavigate={handleNavigate} 
                    hasMore={invoicesHasMore}
                    onLoadMore={() => fetchInvoices(false, searchName, selectedSort)} 
                />
            )
        }
    ];

    return (
            <div>
                <PageMenu items={items} defaultActive={'all'} title={'Rechnungen'} />
            </div>
    );
}

export default Invoice;